<div class="action-box-wrapper">
  <div class="action-box">
    <p class="action-box__title">{{ title | translate }}</p>
    <button class="action-box__button btn btn-outline-bordered btn-square" (click)="onActionClick()">
      {{ actionButtonText | translate | uppercase }}
    </button>
  </div>

  <div *ngIf="isShowHint" class="hint-box">
    {{ hint | translate }}
  </div>
</div>
